import React from 'react';
import PropTypes from 'prop-types';
import Rule from '../criteria-rule';

/**
 * Rule component requiring a lowercase character.
 *
 * @displayName IncludeLowercaseRule
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
export default function IncludeLowercaseRule(props) {
  return (
    <Rule validate={ (v) => /[a-z]/.test(v) } { ...props }>
      { props.children }
    </Rule>
  );
}

/**
 * PropType validation.
 *
 * @type {Object}
 * @private
 */
IncludeLowercaseRule.propTypes = {
  /** Child elements */
  children: PropTypes.node
};
